import React from 'react'
import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

function CruisePageSpecialOffersCarousel() {
  const intl = useIntl()
  const filters: App.OfferListFilters = {
    isSpecialOffers: true,
  }

  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const viewAllLabel = intl.formatMessage({
    id: 'tmjktKfp5r',
    defaultMessage: 'View all',
    description: 'Button text to view all best value cruise offers',
  })

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="gCn5nr8uK9"
            defaultMessage="Best <i>value</i> cruise offers"
            description="Section heading for best value cruise offers"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          {viewAllLabel}
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageSpecialOffersCarousel
